module.exports = __webpack_public_path__ + "img/YJ.504571ca.png";